<template>
  <v-autocomplete
    v-model="vModel"
    v-bind="$attrs"
    :items="items"
    item-text="category_name"
    item-value="id"
  >
    <template #item="data">
      <v-list-item-content
        v-if="data.item.m0601_id === null"
        class="font-weight-bold"
      >
        {{ data.item.category_name }}
      </v-list-item-content>
      <v-list-item-content
        v-else
        class="ml-3"
      >
        <v-list-item-title>{{ data.item.category_name }}</v-list-item-title>
        <v-list-item-subtitle>{{ items.find(category => category.id === data.item.m0601_id).category_name }}</v-list-item-subtitle>
      </v-list-item-content>
    </template>
  </v-autocomplete>
</template>

<script>
export default {
  name: 'TTCCategoryField',

  props: {
    value: {
      type: Number,
      default: null
    },
    items: {
      type: Array,
      default: () => []
    }
  },

  computed: {
    vModel: {
      get () {
        return this.value
      },
      set (value) {
        this.$emit('input', value)
      }
    }
  }
}
</script>
